import Events from './components/Events';

function App( { params }, props ) {
  return (
    <Events params={ params } />
  );
}

export default App;
